import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface TestModeButtonProps {
  onClick: () => void;
  visible: boolean;
}

export const TestModeButton = ({ onClick, visible }: TestModeButtonProps) => {
  if (!visible) return null;

  return (
    <div className="fixed md:absolute bottom-4 right-4 z-10">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              onClick={onClick}
              variant="ghost"
              size="sm"
              className="px-2 py-1 text-xs text-gray-400 hover:text-gray-600"
            >
              Test Mode
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Load test configuration (optional JSON)</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
